<template>
  <div class="detailPage">
    <div class="detailTitle" ref="novelNav" @click="goBack">
      <i class="el-icon-arrow-left" style="margin-right: 5px;margin-top: 4px;"></i>
      <span>{{ bookInfo.book_title }}</span>
    </div>
    <div class="content pc">
      <div class="description">
        <div class="img-box">
          <el-image :src="bookInfo.cover_url" lazy alt="">
                <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                </div>
            </el-image>
        </div>
          <div>
            <div class="novel-title">{{ bookInfo.book_title }}</div>
        <!-- <div class="author">作者</div> -->
        <div class="novel-status author">
          <div class="t">{{ bookInfo.is_finish_text }}</div>
          <div class="t">{{ bookInfo.word_count }}字</div>
        </div>
        <!-- 小说简介 -->
        <div class="synopsis">
          <div class="sy-title">作品简介</div>
          <div class="descr">
            <span>简介:</span>
              <span>{{ showAll? bookInfo.description:subDescrip }}</span>
              <span v-if="bookInfo.description.length>50">
                <span class="expend" style="color: blue;" @click="showAll=!showAll">{{ showAll?'收起':'展开' }}</span>
              </span>
          </div>
          <div class="tags">
            <div class="tag">
              <span class="tag-content">{{ bookInfo.category_name }}</span>
            </div>
          </div>
        </div>
          </div>
      </div>
      <!-- 小说详情 -->
      <div class="novel-detail">
        <div class="content-title">{{ bookInfo.book_title  }}</div>
        <!-- 文章内容 -->
        <div class="novel" v-html="bookInfo.content">

        </div>
        <div class="charge">
          <div class="charge-mask"></div>
          <div>以下是收费内容</div>
        </div>
      </div>
      
      <div class="toolbox">
        <el-tooltip class="item" effect="dark" content="复制Bookid" placement="left">
          <el-button icon="el-icon-notebook-2" @click="copyTo(bookInfo.book_id)" circle></el-button>
        </el-tooltip>
        <el-tooltip class="item" style="margin-top: 10px;" effect="dark" content="复制小说内容" placement="left">
          <el-button icon="el-icon-document-copy" @click="copyNovel" circle></el-button>
        </el-tooltip>
      </div>


    </div>

    <div class="content mobile">
        <div class="hearder-box">
          <div class="left-header">
              <div class="img-box">
                <el-image :src="bookInfo.cover_url" lazy alt="">
                <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                </div>
            </el-image>
              </div>
              <div class="nov-info">
                  <div class="nov-title">{{ bookInfo.book_title }}</div>
                  <div class="nov-status status"><span style="margin-right: 8px;">{{ bookInfo.is_finish_text }}</span><span>{{ bookInfo.word_count }}字</span></div>
                  <!-- <div class="author status">山海晚风</div> -->
              </div>
          </div>
          <div class="intro">
              <span>简介:</span>
              <span>{{ showAll? bookInfo.description:subDescrip }}</span>
              <span v-if="bookInfo.description.length>50">
                <span class="expend" @click="showAll=!showAll">{{ showAll?'收起':'展开' }}</span>
              </span>
          </div>
          <div class="tag-box">
            <div class="tags">{{ bookInfo.category_name }}</div>
          </div>
        </div>

        <!-- 小说内容 -->
        <div class="novel-detail">
          <div class="content-title">{{ bookInfo.name }}</div>
          <!-- 文章内容 -->
          <div class="novel" ref="novelpc" v-html="bookInfo.content">

          </div>
          <div class="charge">
            <div class="charge-mask"></div>
            <div>以下是收费内容</div>
          </div>
          <div class="mobilebtn">
            <el-button type="primary" @click="copyTo(bookInfo.book_id)" round>复制bookid</el-button>
            <el-button type="success" @click="copyNovel" round>复制小说内容</el-button>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getBookDetail } from '../../api/index'
export default {
  components: {

  },
  data() {

    return {
      navHeight: null,
      bookInfo:[],
      bookid:null,
      chapter_id:null,
      showAll:false,
      subDescrip:''
    }

  },
  mounted() {
    this.chapter_id = this.$route.query.chapter_id
    this.bookid = this.$route.query.bookid
    this.getBookInfo()
  },
  methods: {
    copyNovel(){
      const novel = this.$refs.novelpc.innerText
      this.copyTo(novel)
    },
    copyTo(val){
      const textArea = document.createElement('textArea')
            textArea.value = val
            textArea.style.width = 0
            textArea.style.position = 'fixed'
            textArea.style.left = '-999px'
            textArea.style.top = '10px'
            textArea.setAttribute('readonly', 'readonly')
            document.body.appendChild(textArea)

            textArea.select()
            document.execCommand('copy')
            if (document.execCommand('copy')) {
                this.$message({
                    message: '内容已成功复制到剪切板',
                    type: 'success'
                })
            } else {
                this.$message('复制失败')
            }
            document.body.removeChild(textArea)

    },  
    goBack() {
      this.$router.go(-1)
    },
    async getBookInfo(){
      const res=  await getBookDetail({book_id:this.bookid,chapter_id:this.chapter_id})
      
      this.bookInfo = res.data
      if (res.data.description.length > 50) {
        this.subDescrip = res.data.description.substring(0, 50) + "..."
      } else {
        this.subDescrip = res.data.description
      }
    },
    
  }
}
</script >
<style lang="scss" scoped>
@media screen and (min-width: 1079px) {
  .mobile {
    display: none !important;
  }
  .pc {
    display: block;
  }
  .detailPage {
    width: 1080px;
    margin: 0 auto;
    height: calc(100vh - 50px);
    margin-top: 50px;
    position: relative;

    .detailTitle {
      display: flex;
      align-items: center;
      font-size: 20px;
      font-weight: 600;
      padding: 20px 0;
      z-index: 20;
      cursor: pointer;
    }

    .content {
      display: flex;
      height: calc(100vh - 120px);
      position: relative;
      .description {
        width: 360px;
        padding: 30px;
        border-radius: 10px;
        align-self: flex-start;
        background: #fff;
        max-height: 100%;
        overflow: auto;
        .img-box {
          width: 120px;
          height: 160px;
          margin: 0 auto 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f5f7fa;
        }

        .novel-title {
          color: #000;
          font-size: 18px;
          font-weight: 500;
          line-height: 28px;
          text-align: center;
        }

        .author {
          color: rgba(0, 0, 0, .4);
          font-size: 14px;
          line-height: 22px;
          margin-top: 8px;
          text-align: center;
        }

        .novel-status {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 30px;

          .t {
            &::after {
              display: inline-block;
              background-color: rgba(0, 0, 0, .4);
              box-sizing: border-box;
              content: ' ';
              height: 8px;
              width: 1px;
              margin: 0 5px;
            }
          }
        }

        .synopsis {
          .sy-title {
            color: rgba(0, 0, 0, .8);
            flex: none;
            font-size: 16px;
            font-weight: 500;
            line-height: 22px;
            margin-right: 12px;
            margin-bottom: 12px;
          }

          .descr {
            color: rgba(0, 0, 0, .4);
            font-size: 14px;
            line-height: 22px;
            margin-bottom: 8px;
          }

          .tags {

            display: flex;
            align-items: center;
            flex-wrap: wrap;
            margin-bottom: -10px;

            .tag {
              background-color: rgba(0, 0, 0, .04);
              border-radius: 4px;
              color: rgba(0, 0, 0, .4);
              font-weight: 400;
              margin-bottom: 10px;
              margin-right: 10px;
              font-size: 12px;
              font-weight: 500;
              height: 24px;
              line-height: 22px;
              padding: 0 8px;

              .tag-content {
                flex: 1 1;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
        }
      }

      .novel-detail {
        border-radius: 12px 12px 0 0;
        height: 100%;
        margin-left: 12px;
        position: relative;
        width: 100%;
        height: 100%;
        background: #fff;
        padding: 32px 64px;
        overflow: scroll;
        .content-title {
          font-size: 24px;
          font-weight: 500;
          line-height: 34px;
          margin-bottom: 32px;
          position: relative;
          z-index: 1;
        }

        .novel {
          box-sizing: border-box;
          font-size: 16px;
          line-height: 200%;
          margin-bottom: 12px;
          width: 100%;
          word-break: break-word;
        }

        .charge {
          align-items: center;
          color: #a47124;
          display: -webkit-flex;
          display: flex;
          height: 22px;
          justify-content: center;
          line-height: 22px;
          margin-top: 16px;
          position: relative;
          text-align: center;

          .charge-mask {
            background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
            bottom: 32px;
            height: 211px;
            left: 0;
            pointer-events: none;
            position: absolute;
            right: 0;
          }

          &::before {
            background: linear-gradient(270deg, #a47124, rgba(164, 113, 36, 0));
            content: "";
            height: 1px;
            width: 210px;
            margin-right: 5px;
          }

          &::after {
            transform: scaleX(-1);
            background: linear-gradient(270deg, #a47124, rgba(164, 113, 36, 0));
            content: "";
            height: 1px;
            width: 210px;
            margin-left: 5px;
          }
        }
      }
      .toolbox {
        position: absolute;
        right: -80px;
        bottom: 50px;
        width: 50px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        ::v-deep .el-button+.el-button, .el-checkbox.is-bordered+.el-checkbox.is-bordered {
          margin-left: 0;
        }
      }
    }

    ::-webkit-scrollbar {
      display: none;
    }
  }
}

@media screen and (max-width: 1079px) {
  .pc {
    display: none;
  }
  .mobile {
    display: block;
  }
  .detailPage {
    width: 100%;

    padding-top: 44px;
    padding-bottom: 60px;
    .detailTitle {
      position: fixed;
      top: 0;
      width: 100%;
      height: 44px;
      background: #f1cec2;
      display: flex;
      align-items: center;
      padding-left: 10px;
      z-index: 20;
    }
    .content {
      .hearder-box {
        width: 100%;
        padding: 30px 25px;
        padding-bottom: 10px;
        background: #fff;
        .left-header {
          display: flex;
          .img-box {
            width: 98px;
            height: 128px;
            border-radius: 10px;
            overflow: hidden;
            display: flex;
          align-items: center;
          justify-content: center;
          background: #f5f7fa;
          }
          .nov-info {
            flex: 1;
            margin-left:20px;
            .nov-title {
              color: #000;
              font-size: 18px;
              font-weight: 500;
              line-height: 28px;
              margin-bottom: 15px;
            }
            .status {
              font-size: 14px;
              line-height: 22px;
              margin-top: 8px;
              color: rgba(0, 0, 0, 0.4);
            }
          }
        }
        .intro {
          margin-top: 20px;
          font-size: 16px;
          line-height: 200%;
          .expend {
            color: #0075ff;
          }
        }
        .tag-box {
          display: flex;
          flex-wrap: wrap;
          .tags {
            background-color: rgba(0, 0, 0, 0.04);
            border-radius: 4px;
            color: rgba(0, 0, 0, 0.4);
            font-weight: 400;
            margin-bottom: 10px;
            margin-right: 10px;
            font-size: 12px;
            font-weight: 500;
            height: 24px;
            line-height: 24px;
            padding: 0 8px;
            margin-top: 10px;
          }
        }
      }
      .novel-detail {
        background: #fff;
        margin-top: 5px;
        padding: 10px 25px;
        .content-title {
          font-size: 20px;
          margin-bottom: 20px;
        }
        .novel {
          box-sizing: border-box;
    font-size: 16px;
    line-height: 200%;
    margin-bottom: 12px;
    width: 100%;
    word-break: break-word;
        }
        .charge {
          align-items: center;
          color: #a47124;
          display: -webkit-flex;
          display: flex;
          height: 22px;
          justify-content: center;
          line-height: 22px;
          margin-top: 16px;
          position: relative;
          text-align: center;

          .charge-mask {
            background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
            bottom: 32px;
            height: 211px;
            left: 0;
            pointer-events: none;
            position: absolute;
            right: 0;
          }

          &::before {
            background: linear-gradient(270deg, #a47124, rgba(164, 113, 36, 0));
            content: "";
            height: 1px;
            width: 100px;
            margin-right: 5px;
          }

          &::after {
            transform: scaleX(-1);
            background: linear-gradient(270deg, #a47124, rgba(164, 113, 36, 0));
            content: "";
            height: 1px;
            width: 100px;
            margin-left: 5px;
          }
        }
      }
    }
    .mobilebtn {
      position: fixed;
      height: 60px;
      bottom: 0;
      left: 0;
      width: 100%;
      background-color: #f6f6f6;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
    